export default "__VITE_ASSET__aa18b1dc__"